import { useEffect, useRef, useState } from "react";
import { BACKEND } from "../../config/configEnvs";
import axios from "axios";
import HandleUpdateTextSelf from "../../utils/HandleUpdateTextSelf";

const DemoAccessBox = ({serviceId}) => {

  const debounceUpdate = useRef(null)
  
  const [serviceData, setServiceData] = useState({})

  const getData = async () => {
    try {
      const response = await axios.get(`${BACKEND}/api/serviciosCotizaciones/${serviceId}`)
      setServiceData(response.data)
    } catch (e) {
      console.log(e)
    }
  }

  useEffect(() => {
    if (serviceId) {
      getData()
    }
  }, [serviceId])

  return (
    <div className="flex flex-col gap-2">
      <h3 className="text-sm font-bold text-slate-600 mb-1">Accesos demo</h3>

      <div className="flex flex-row w-full items-center justify-center text-xs text-gray-700">
        <span className="w-[20%] px-4 text-center">Nombre</span>
        <span className="w-[40%] px-4 text-center">Cuenta</span>
        <span className="w-[40%] px-4 text-center">Contraseña</span>
      </div>
      
      {/* Accesos admin */}
      <div className="flex flex-row w-full bg-white shadow-sm rounded-lg border border-gray-200 hover:shadow-md transition-all">
        
        {/* Título */}
        <div className="w-[20%] flex items-center justify-start px-2 py-2 border-r border-gray-300">
          <span className="text-xs font-medium text-gray-700 break-words">
            Accesos admin
          </span>
        </div>

        {/* Inputs */}
        <div className="w-[80%] flex items-center justify-start px-2 py-2 border-r border-gray-300">
          <input
            value={serviceData?.cuentaAdmin || ""}
            onChange={(e) => HandleUpdateTextSelf("cuentaAdmin", e.target.value, serviceId, "serviciosCotizaciones", debounceUpdate, setServiceData)}
            className="text-xs w-full border border-gray-200 text-blue-600 underline py-2 hover:text-blue-800"
          />
          <input
            value={serviceData?.passAdmin || ""}
            onChange={(e) => HandleUpdateTextSelf("passAdmin", e.target.value, serviceId, "serviciosCotizaciones", debounceUpdate, setServiceData)}
            className="text-xs w-full border border-gray-200 text-blue-600 underline py-2 hover:text-blue-800"
          />
        </div>

      </div>

      {/* Accesos profesor */}
      <div className="flex flex-row w-full bg-white shadow-sm rounded-lg border border-gray-200 hover:shadow-md transition-all">
  
        {/* Título */}
        <div className="w-[20%] flex items-center justify-start px-2 py-2 border-r border-gray-300">
          <span className="text-xs font-medium text-gray-700 break-words">
            Accesos profesor
          </span>
        </div>

        {/* Inputs */}
        <div className="w-[80%] flex items-center justify-start px-2 py-2 border-r border-gray-300">
          <input
            value={serviceData?.cuentaProfesor || ""}
            onChange={(e) => HandleUpdateTextSelf("cuentaProfesor", e.target.value, serviceId, "serviciosCotizaciones", debounceUpdate, setServiceData)}
            className="text-xs w-full border border-gray-200 text-blue-600 underline py-2 hover:text-blue-800"
          />
          <input
            value={serviceData?.passProfesor || ""}
            onChange={(e) => HandleUpdateTextSelf("passProfesor", e.target.value, serviceId, "serviciosCotizaciones", debounceUpdate, setServiceData)}
            className="text-xs w-full border border-gray-200 text-blue-600 underline py-2 hover:text-blue-800"
          />
        </div>

      </div>

      {/* Accesos estudiante */}
      <div className="flex flex-row w-full bg-white shadow-sm rounded-lg border border-gray-200 hover:shadow-md transition-all">
  
        {/* Título */}
        <div className="w-[20%] flex items-center justify-start px-2 py-2 border-r border-gray-300">
          <span className="text-xs font-medium text-gray-700 break-words">
            Accesos estudiante
          </span>
        </div>

        {/* Inputs */}
        <div className="w-[80%] flex items-center justify-start px-2 py-2 border-r border-gray-300">
          <input
            value={serviceData?.cuentaEstudiante || ""}
            onChange={(e) => HandleUpdateTextSelf("cuentaEstudiante", e.target.value, serviceId, "serviciosCotizaciones", debounceUpdate, setServiceData)}
            className="text-xs w-full border border-gray-200 text-blue-600 underline py-2 hover:text-blue-800"
          />
          <input
            value={serviceData?.passEstudiante || ""}
            onChange={(e) => HandleUpdateTextSelf("passEstudiante", e.target.value, serviceId, "serviciosCotizaciones", debounceUpdate, setServiceData)}
            className="text-xs w-full border border-gray-200 text-blue-600 underline py-2 hover:text-blue-800"
          />
        </div>

      </div>

    </div>
  )

}

export default DemoAccessBox